<template>
  <div class="tab-content" id="PTtab-1" :key="'PTtab-1'" >
    <div class="pagenamPT">
      <h3 class="pagename2">{{ $t('front.common.dailyPartner') }}</h3>
    </div>
    <div class="sch_PC">
      <div class="PTsch flex-c">
        <div class="datesearchPTWarp flex-c gap-2">
          <h4>날짜</h4>
          <date-filter :retail="true" @search="loadMainTable(1)"
                     @update="onChangeDateTable"
                     :defaultDay="0"
                     :startDate="mainTableDate.startDate"
                     :endDate="mainTableDate.endDate"
                     :isOldYn="true"
                     :id="'main-date-checkbox1'"
                     @setOldYn="setOldYn" :oldYn="reqData.oldYn" />
        </div>
      </div>
    </div>
    <div class="sch_M">
      <div class="PTsch flex-c">
        <div class="datesearchM">
          <date-filter-mobile :retail="true" @search="loadMainTable(1)"
                          @update="onChangeDateTable"
                          :defaultDay="0"
                          :startDate="mainTableDate.startDate"
                          :endDate="mainTableDate.endDate"
                          :isOldYn="true"
                          :id="'main-date-checkbox1'"
                          @setOldYn="setOldYn" :oldYn="reqData.oldYn"/>
        </div>
      </div>
    </div>
    <!-- <div class="sch_Normal">
      <div class="sch_Btm">
        <div class="searchPTwrap">
          <div class="searchPT w30p">
            <div class="datesearchPT flex-c gap-2">
              <h4>구분</h4>
              <select class="h36px">
                <option value="memId" selected>아이디</option>
              </select>
            </div>
          </div>
          <div class="searchPT">
            <input type="text" :placeholder="$t('front.search.emptySearch')" v-model="searchMemId" class="h36px"/>
            <a @click="loadMainTable(1)" class="sch_Icon">
              <img src="@/assets/img/search.png" alt=""/>
            </a>
          </div>
        </div>
      </div>
    </div> -->
    <ul class="strbtnPT mb20">
      <li>{{$t('front.common.deposit')}}<span>{{thousand(total.userCashIn || 0)}}</span></li>
      <li>{{$t('front.common.withdrawal')}}<span>{{thousand(total.userCashOut || 0)}}</span></li>
      <li>입출차액<span>{{thousand(total.userCashResultAmt || 0)}}</span></li>
      <li>{{$t('front.stributor.m22')}}<span>{{thousand(total.betAmt || 0)}}</span></li>
      <li>{{$t('front.stributor.m23')}}<span>{{thousand(total.betAmtWin || 0)}}</span></li>
      <li>{{$t('front.stributor.winlose')}}<span>{{thousand(total.betResultAmt || 0)}}</span></li>
    </ul>
    <div class="line"><retail-main-table v-model:partnerObj=partnerLevelObject :list="list" :date="mainTableDate" :table="'main'" :mainPageInfo=pageInfo  @goToMainPage="loadMainTable" /></div>

    <div v-if="move" class="moveWrap makeWrap">
      <div class="makeWraphead">
        <h4>요율조정</h4>
        <a @click="move=!move" class="close"><img src="@/assets/img/icon_cancelW.svg" /></a>
      </div>
      <div class="makeWrapbody">
        <div>
          <p class="name">내요율</p>
          <table class="rolllose">
            <tr>
              <th></th>
              <th v-if="gameCount['casino']">{{$t('front.gnb.casino')}}</th>
              <th v-if="gameCount['hc-casino']">{{$t('front.gnb.hotelcasino')}}</th>
              <th v-if="gameCount['slot']">{{$t('front.gnb.slot')}}</th>
              <th v-if="gameCount['sports']">{{$t('front.gnb.sport')}}</th>
              <th v-if="gameCount['mini-game'] || gameCount['mini game']">{{$t('front.gnb.minigame')}}</th>
            </tr>
            <tr>
              <th>{{$t('front.stributor.roll')}}(%)</th>
              <td v-if="gameCount['casino']">{{myRate.casinoPR}}</td>
              <td v-if="gameCount['hc-casino']">{{myRate.hcasinoPR}}</td>
              <td v-if="gameCount['slot']">{{myRate.slotPR}}</td>
              <td v-if="gameCount['sports']">{{myRate.sportPR}}</td>
              <td v-if="gameCount['mini-game'] || gameCount['mini game']">{{myRate.miniPR}}</td>
            </tr>
            <tr>
              <th>{{$t('front.stributor.lose')}}(%)</th>
              <td v-if="gameCount['casino']">{{myRate.casinoLR}}</td>
              <td v-if="gameCount['hc-casino']">{{myRate.hcasinoLR}}</td>
              <td v-if="gameCount['slot']">{{myRate.slotLR}}</td>
              <td v-if="gameCount['sports']">{{myRate.sportLR}}</td>
              <td v-if="gameCount['mini-game'] || gameCount['mini game']">{{myRate.miniLR}}</td>
            </tr>
          </table>
        </div>
        <div>
          <p class="name">하부회원 요율조정</p>
          <div class="scroll">
            <table class="rolllose2">
              <tr>
                <th>{{$t('front.common.memId')}}<em>({{$t('front.common.nickName')}})</em></th>
                <th>분류</th>
                <th v-if="gameCount['casino']">{{$t('front.gnb.casino')}}</th>
                <th v-if="gameCount['hc-casino']">{{$t('front.gnb.hotelcasino')}}</th>
                <th v-if="gameCount['slot']">{{$t('front.gnb.slot')}}</th>
                <th v-if="gameCount['sports']">{{$t('front.gnb.sport')}}</th>
                <th v-if="gameCount['mini-game'] || gameCount['mini game']">{{$t('front.gnb.minigame')}}</th>
              </tr>
              <template v-if="myChildrenRate.length">
                <template v-for="item in myChildrenRate" :key="item.memId">
                  <tr>
                    <td rowspan="2">{{item.memId}}<em>({{item.memNick}})</em></td>
                    <th>{{$t('front.stributor.roll')}}(%)</th>
                    <td v-if="gameCount['casino']"><input @change="onChangeChildrenRate(item)" :class="{'error': item.casinoPRError}" type="text" v-model="item.casinoPR" :disabled="userData.updId == 'royal77'"></td>
                    <td v-if="gameCount['hc-casino']"><input @change="onChangeChildrenRate(item)" :class="{'error': item.hcasinoPRError}" type="text" v-model="item.hcasinoPR" :disabled="userData.updId == 'royal77'"></td>
                    <td v-if="gameCount['slot']"><input @change="onChangeChildrenRate(item)" :class="{'error': item.slotPRError}" type="text" v-model="item.slotPR" :disabled="userData.updId == 'royal77'"></td>
                    <td v-if="gameCount['sports']"><input @change="onChangeChildrenRate(item)" :class="{'error': item.sportPRError}" type="text" v-model="item.sportPR" :disabled="userData.updId == 'royal77'"></td>
                    <td v-if="gameCount['mini-game']">
                      <button class="detailSet" @click="toggleDetailSet(item)">세부설정</button>
                    </td>
                    <div class="detailSetWrap" v-if="isSelectedRow(item)">
                      <table>
                        <tbody>
                          <tr>
                            <td rowspan="2" class="tableheadside">일반</td>
                            <td>롤링</td>
                            <td>
                              <button>최소</button>
                              <input>
                              <button>최대</button>
                            </td>
                          </tr>
                          <tr>
                            <td>롤링</td>
                            <td>
                              <button>최소</button>
                              <input>
                              <button>최대</button>
                            </td>
                          </tr>
                          <tr>
                            <td rowspan="2" class="tableheadside">조합</td>
                            <td>루징</td>
                            <td>
                              <button>최소</button>
                              <input>
                              <button>최대</button>
                            </td>
                          </tr>
                          <tr>
                            <td>루징</td>
                            <td>
                              <button>최소</button>
                              <input>
                              <button>최대</button>
                            </td>
                          </tr>
                        </tbody>
                      </table>
                      <button class="detailSetSave">저장</button>
                      <span @click="toggleDetailSet" class="detailClose">×</span>
                    </div>
                  </tr>
                  <tr>
                    <th>{{$t('front.stributor.lose')}}(%)</th>
                    <td v-if="gameCount['casino']"><input @change="onChangeChildrenRate(item)" :class="{'error': item.casinoLRError}" type="text" v-model="item.casinoLR" :disabled="userData.updId == 'royal77'"></td>
                    <td v-if="gameCount['hc-casino']"><input @change="onChangeChildrenRate(item)" :class="{'error': item.hcasinoPRError}" type="text" v-model="item.hcasinoLR" :disabled="userData.updId == 'royal77'"></td>
                    <td v-if="gameCount['slot']"><input @change="onChangeChildrenRate(item)" :class="{'error': item.slotLRError}" type="text" v-model="item.slotLR" :disabled="userData.updId == 'royal77'"></td>
                    <td v-if="gameCount['sports']"><input @change="onChangeChildrenRate(item)" :class="{'error': item.sportLRError}" type="text" v-model="item.sportLR" :disabled="userData.updId == 'royal77'"></td>
                    <td v-if="gameCount['mini-game']">
                      <button class="detailSet" @click="toggleDetailSetlosing(item)">세부설정</button>
                    </td>
                    <div class="detailSetWrap detailLosing" v-if="isSelectedRowlosing(item)">
                      <table>
                        <tbody>
                          <tr>
                            <td rowspan="2" class="tableheadside">일반</td>
                            <td>롤링</td>
                            <td>
                              <button>최소</button>
                              <input>
                              <button>최대</button>
                            </td>
                          </tr>
                          <tr>
                            <td>롤링</td>
                            <td>
                              <button>최소</button>
                              <input>
                              <button>최대</button>
                            </td>
                          </tr>
                          <tr>
                            <td rowspan="2" class="tableheadside">조합</td>
                            <td>루징</td>
                            <td>
                              <button>최소</button>
                              <input>
                              <button>최대</button>
                            </td>
                          </tr>
                          <tr>
                            <td>루징</td>
                            <td>
                              <button>최소</button>
                              <input>
                              <button>최대</button>
                            </td>
                          </tr>
                        </tbody>
                      </table>
                      <button class="detailSetSave">저장</button>
                      <span @click="toggleDetailSetlosing" class="detailClose">×</span>
                    </div>
                  </tr>
                </template>
              </template>
            </table>
          </div>
        </div>
        <p>하부회원의 최대 요율은 내 상위요율을 넘을 수 없습니다. 최소요율은 해당회원의 하부 최대 요율보다 낮을 수 없습니다.</p>
        <div class="btnWrap">
          <a class="btn" @click="onUpdateChildrenRate">{{$t('front.stributor.save')}}</a>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {
  partnerLevels, retailMemRate, retailMyCalculate, retailUpdate
} from '@/api/retail'
import DateFilter from '@/components/ui/DateFilter'
import DateFilterMobile from '@/components/ui/DateFilterMobile'
import RetailMainTable from '@/components/member/stributor/RetailMainTable.vue'
import { getDateStr, thousand } from '@/libs/utils'
import { addDays } from 'date-fns'
import { mapState } from 'vuex'
export default {
  name: 'PartnerCash',
  components: {
    DateFilter,
    RetailMainTable,
    DateFilterMobile
  },
  computed: {
    ...mapState([
      'userData',
      'gameCount',
      'commonCodeByOrder',
      'commonCodeByCode'
    ])
  },
  data () {
    return {
      mainTableDate: {
        startDate: getDateStr(addDays(new Date(), 0), 'yyyy-MM-dd 00:00:00'),
        endDate: getDateStr(addDays(new Date(), 0), 'yyyy-MM-dd 23:59:59')
      },
      reqData: {
        searchType: 'OUTER',
        chkTodayYn: 'N',
        startDate: '',
        endDate: '',
        offset: -1,
        oldYn: 'N'
      },
      list: [],
      pageInfo: {

      },
      move: false,
      make: false,
      total: {},
      searchType: 'P',
      partnerLevelList: [],
      partnerLevelObject: null,
      myRate: {},
      myChildrenRate: [],
      selectedRow: null,
      selectedRowlosing: null,
      detailSet: false,
      searchMemId: null
    }
  },
  async created () {
    this.emitter.emit('Loading', true)
    this.onLoadRate()
    this.getPartnerLevels()
    this.reqData.startDate = this.mainTableDate.startDate.split(' ')[0]
    this.reqData.endDate = this.mainTableDate.endDate.split(' ')[0]

    await this.loadMainTable()

    this.emitter.emit('Loading', false)
  },
  methods: {
    detailSetOpen () {
      this.detailSet = !this.detailSet
    },
    toggleDetailSet (item) {
      if (this.isSelectedRow(item)) {
        this.selectedRow = null
      } else {
        this.selectedRow = item
      }
    },
    isSelectedRow (item) {
      return this.selectedRow === item
    },
    toggleDetailSetlosing (item) {
      if (this.isSelectedRow(item)) {
        this.selectedRowlosing = null
      } else {
        this.selectedRowlosing = item
      }
    },
    isSelectedRowlosing (item) {
      return this.selectedRowlosing === item
    },
    onChangeChildrenRate (item) {
      const casinoPR = Number(item.casinoPR)
      if (casinoPR || casinoPR === 0) {
        const maxCasinoPR = Number(item.maxCasinoPR)
        const minCasinoPR = Number(item.minCasinoPR)
        if (maxCasinoPR < casinoPR || minCasinoPR > casinoPR) {
          item.casinoPRError = true
        } else {
          item.casinoPRError = false
        }
      }

      const hcasinoPR = Number(item.hcasinoPR)
      if (hcasinoPR || hcasinoPR === 0) {
        const maxHcasinoPR = Number(item.maxHcasinoPR)
        const minHcasinoPR = Number(item.minHcasinoPR)
        console.log(hcasinoPR, maxHcasinoPR, minHcasinoPR)
        if (maxHcasinoPR < hcasinoPR || minHcasinoPR > hcasinoPR) {
          item.hcasinoPRError = true
        } else {
          item.hcasinoPRError = false
        }
      }

      const slotPR = Number(item.slotPR)
      if (slotPR || slotPR === 0) {
        const maxSlotPR = Number(item.maxSlotPR)
        const minSlotPR = Number(item.minSlotPR)
        if (maxSlotPR < slotPR || minSlotPR > slotPR) {
          item.slotPRError = true
        } else {
          item.slotPRError = false
        }
      }

      const miniPR = Number(item.miniPR)
      if (miniPR || miniPR === 0) {
        const maxMiniPR = Number(item.maxMiniPR)
        const minMiniPR = Number(item.minMiniPR)
        if (maxMiniPR < miniPR || minMiniPR > miniPR) {
          item.miniPRError = true
        } else {
          item.miniPRError = false
        }
      }

      const casinoLR = Number(item.casinoLR)
      if (casinoLR || casinoLR === 0) {
        const maxCasinoLR = Number(item.maxCasinoLR)
        const minCasinoLR = Number(item.minCasinoLR)
        if (maxCasinoLR < casinoLR || minCasinoLR > casinoLR) {
          item.casinoLRError = true
        } else {
          item.casinoLRError = false
        }
      }

      const hcasinoLR = Number(item.hcasinoLR)
      if (hcasinoLR || hcasinoLR === 0) {
        const maxHcasinoLR = Number(item.maxHcasinoLR)
        const minHcasinoLR = Number(item.minHcasinoLR)
        if (maxHcasinoLR < hcasinoLR || minHcasinoLR > hcasinoLR) {
          item.hcasinoLRError = true
        } else {
          item.hcasinoLRError = false
        }
      }

      const slotLR = Number(item.slotLR)
      if (slotLR || slotLR === 0) {
        const maxSlotLR = Number(item.maxSlotLR)
        const minSlotLR = Number(item.minSlotLR)
        if (maxSlotLR < slotLR || minSlotLR > slotLR) {
          item.slotLRError = true
        } else {
          item.slotLRError = false
        }
      }

      const miniLR = Number(item.miniLR)
      if (miniLR || miniLR === 0) {
        const maxMiniLR = Number(item.maxMiniLR)
        const minMiniLR = Number(item.minMiniLR)
        if (maxMiniLR < miniLR || minMiniLR > miniLR) {
          item.miniLRError = true
        } else {
          item.miniLRError = false
        }
      }
    },
    async onUpdateChildrenRate () {
      const rateList = this.myChildrenRate
      console.log(rateList)

      for (let i = 0, iLen = rateList.length; i < iLen; i++) {
        const item = rateList[i]
        if (item.casinoLRError ||
          item.casinoPRError ||
          item.hcasinoPRError ||
          item.hcasinoLRError ||
          item.slotLRError ||
          item.slotPRError ||
          item.miniLRError ||
          item.miniPRError
        ) {
          return
        }
      }

      const confirm = await this.onConfirm('front.common.confirmSave')
      if (confirm) {
        const param = {
          siteId: '',
          memId: '',
          rateList: rateList
        }

        this.emitter.emit('Loading', true)
        retailUpdate(param).then(res => {
          this.emitter.emit('Loading', false)
          const data = res.data
          if (data.resultCode === '0') {
            this.onCheck('front.recommender.complete')
            this.onLoadRate()
          }
        })
      }
    },
    onLoadRate () {
      retailMemRate({}).then(res => {
        const data = res.data
        if (data.resultCode === '0') {
          this.myRate = data.data.myCategoryRate
          this.myChildrenRate = data.data.botCategoryRateList
        }
      })
    },
    thousand,

    setOldYn (data) {
      this.reqData.oldYn = data
    },
    getPartnerLevels () {
      partnerLevels({}).then(res => {
        const result = res.data
        if (result.resultCode === '0') {
          this.partnerLevelList = result.data.list
          this.newPartnerLevel = result.data.list[0]

          const partnerObj = {}
          for (let i = 0; i < this.partnerLevelList.length; i++) {
            const item = this.partnerLevelList[i]
            const code = item.code
            const codeName = item.codeName

            if (!partnerObj[code]) {
              partnerObj[code] = codeName
            }
          }

          this.partnerLevelObject = partnerObj
        }
      })
    },
    onChangeDateTable (value) {
      this.reqData.startDate = getDateStr(new Date(value.startDate))
      this.reqData.endDate = getDateStr(new Date(value.endDate))
    },
    async loadMainTable (page) {
      if (!page) {
        page = 1
      }
      this.emitter.emit('Loading', true)
      const params = {
        ...this.reqData,
        count_per_list: 20,
        page: page
      }

      if (this.searchMemId) {
        params.searchMemId = this.searchMemId
      }

      this.mainTableDate.startDate = this.reqData.startDate
      this.mainTableDate.endDate = this.reqData.endDate

      const today = new Date()
      if (params.endDate === getDateStr(today)) {
        params.chkTodayYn = 'Y'
      } else {
        params.chkTodayYn = 'N'
      }

      await retailMyCalculate(params).then(res => {
        window.scrollTo(0, 0)
        const data = res.data
        if (data.resultCode === '0') {
          this.list = data.data.outSearchList
          this.pageInfo = data.data.search
          this.total = data.data.outSearchTotal
        }

        this.emitter.emit('Loading', false)
      })
    }
  }
}
</script>
<style scoped src="@/styles/common.css"></style>
<style scoped src="@/styles/striNew.css"></style>
<style scoped>
.tab-content {
  min-height: calc(100vh - 58px);
  padding: 28px 28px 44px;
  background: #f4f7fb;
  box-sizing: border-box;
}

.pagenamPT {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin: 0 0 18px;
}

.pagename2 {
  margin: 0;
  color: #0f172a;
  font-size: 22px;
  font-weight: 800;
  letter-spacing: -0.5px;
  line-height: 1.25;
}

/* 검색 영역 */
.sch_PC {
  margin: 0 0 14px;
  padding: 18px 16px;
  background: #fff;
  border: 1px solid #dce5f2;
  border-radius: 12px;
  box-shadow: 0 10px 24px rgba(15, 23, 42, 0.045);
  box-sizing: border-box;
}

.sch_M {
  display: none;
}

.PTsch,
.datesearchPTWarp,
.datesearchPTWarp.flex-c {
  width: 100%;
  display: flex !important;
  flex-direction: row !important;
  align-items: center !important;
  justify-content: flex-start !important;
  gap: 10px !important;
  margin: 0 !important;
}

.datesearchPTWarp h4 {
  flex: 0 0 auto;
  min-width: 36px;
  margin: 0 2px 0 0 !important;
  color: #334155;
  font-size: 13px;
  font-weight: 800;
  line-height: 38px;
  text-align: left;
}

.sch_PC :deep(.datesearchPT),
.sch_PC :deep(.datesearchPTWarp),
.sch_PC :deep(.datesearch),
.sch_PC :deep(.dateBox),
.sch_PC :deep(.date-filter) {
  display: flex !important;
  flex-direction: row !important;
  align-items: center !important;
  justify-content: flex-start !important;
  gap: 6px !important;
  margin: 0 !important;
  width: auto !important;
}

.sch_PC :deep(input),
.sch_PC :deep(select) {
  height: 38px !important;
  margin: 0 !important;
  padding: 0 10px !important;
  border: 1px solid #d7e0ec !important;
  border-radius: 7px !important;
  background: #fff !important;
  color: #1f2937 !important;
  box-sizing: border-box;
  font-size: 13px !important;
  box-shadow: 0 1px 2px rgba(15, 23, 42, 0.03);
}

.sch_PC :deep(input[type='date']),
.sch_PC :deep(input[type='text']) {
  width: 128px !important;
}

.sch_PC :deep(.dateBtn),
.sch_PC :deep(.bga),
.sch_PC :deep(button),
.sch_PC :deep(a) {
  min-width: 54px;
  height: 38px !important;
  margin: 0 !important;
  padding: 0 13px !important;
  border: 1px solid #c4ceda !important;
  border-radius: 7px !important;
  background: #4b5563 !important;
  color: #fff !important;
  font-size: 13px !important;
  font-weight: 800 !important;
  line-height: 36px !important;
  box-shadow: 0 2px 5px rgba(15, 23, 42, 0.12);
  cursor: pointer;
}

.sch_PC :deep(.dateBtn),
.sch_PC :deep(.bga) {
  background: #2563eb !important;
  border-color: #1d4ed8 !important;
}

.sch_PC :deep(label),
.sch_PC :deep(span) {
  color: #334155;
  font-size: 12px;
  font-weight: 600;
}

/* 총계 카드 */
.strbtnPT {
  display: grid;
  grid-template-columns: repeat(6, minmax(0, 1fr));
  gap: 10px;
  margin: 0 0 14px !important;
  padding: 0 !important;
  list-style: none;
}

.strbtnPT li {
  min-height: 58px;
  padding: 9px 12px;
  background: #fff !important;
  border: 1px solid #dce5f2;
  border-radius: 8px;
  box-shadow: 0 5px 14px rgba(15, 23, 42, 0.055);
  color: #111827;
  font-size: 14px;
  font-weight: 800;
  text-align: center;
  box-sizing: border-box;
}

.strbtnPT li span {
  display: block;
  margin-top: 5px;
  color: #2563eb;
  font-family: 'Roboto', sans-serif;
  font-size: 18px;
  font-weight: 900;
  line-height: 1.2;
}

/* 메인 테이블 카드 */
.line {
  overflow-x: auto;
  background: #fff;
  border: 1px solid #dce5f2;
  border-radius: 12px;
  box-shadow: 0 10px 24px rgba(15, 23, 42, 0.045);
}

.line :deep(.strTablescr),
.line :deep(.table-wrapper),
.line :deep(.main-contents-wrapper),
.line :deep(.content-wrap) {
  width: 100%;
  margin: 0 !important;
  padding: 0 !important;
  background: transparent !important;
  border: 0 !important;
  box-shadow: none !important;
}

.line :deep(table) {
  width: 100%;
  min-width: 1150px;
  border-collapse: separate !important;
  border-spacing: 0 !important;
  background: #fff;
}

.line :deep(thead),
.line :deep(table thead tr) {
  position: relative;
}

.line :deep(thead tr:first-child th) {
  border-top: 3px solid #2563eb !important;
}

.line :deep(th) {
  height: 45px;
  padding: 3px 10px 0;
  background: #f6f9fd !important;
  border-bottom: 1px solid #dfe7f2 !important;
  color: #1f2a3d !important;
  font-size: 13px;
  font-weight: 800;
  text-align: center;
  white-space: nowrap;
  vertical-align: middle;
}

.line :deep(td) {
  height: 48px;
  padding: 10px 10px;
  border-bottom: 1px solid #e8eef6 !important;
  color: #1f2937 !important;
  font-size: 14px;
  text-align: center;
  vertical-align: middle;
  line-height: 1.35;
}

.line :deep(tbody tr:nth-child(even) td) {
  background: #fbfdff !important;
}

.line :deep(tbody tr:hover td) {
  background: #f8fbff !important;
}

.line :deep(tbody tr:last-child td) {
  border-bottom: 0 !important;
}

.line :deep(.plusAmt),
.line :deep(.rdc) {
  color: #f97316 !important;
}

.line :deep(.minusAmt),
.line :deep(.blc) {
  color: #2563eb !important;
}

.line :deep(.box),
.line :deep(.topbox) {
  border-radius: 6px !important;
  box-shadow: none !important;
}

.line :deep(.pagination),
.line :deep(.paging),
.line :deep(.page) {
  margin: 16px 0 !important;
}

.line :deep(.pagination a),
.line :deep(.paging a),
.line :deep(.page a) {
  border-radius: 6px !important;
}

/* 요율조정 팝업 */
.makeWrap {
  border-radius: 12px;
  overflow: hidden;
  box-shadow: 0 15px 40px rgba(15, 23, 42, 0.26);
}

.makeWraphead {
  background: #1e293b !important;
}

.makeWrapbody {
  background: #fff;
}

.makeWrapbody table {
  border-collapse: collapse;
}

.makeWrapbody th {
  background: #f5f8fc;
  color: #243041;
}

.makeWrapbody td,
.makeWrapbody th {
  border: 1px solid #e3e8f1;
}

.makeWrapbody input {
  border: 1px solid #d7deea;
  border-radius: 6px;
}

.detailSet,
.detailSetSave,
.btnWrap .btn {
  border-radius: 7px !important;
  background: #2563eb !important;
  color: #fff !important;
  border: 1px solid #1d4ed8 !important;
  box-shadow: none !important;
}

@media (max-width: 1200px) {
  .strbtnPT {
    grid-template-columns: repeat(3, minmax(0, 1fr));
  }
}

@media (max-width: 1000px) {
  .tab-content {
    padding: 16px 12px 30px;
  }

  .pagenamPT {
    flex-direction: column;
    align-items: flex-start;
    margin-bottom: 14px;
  }

  .pagename2 {
    font-size: 19px;
  }

  .sch_PC {
    display: none;
  }

  .sch_M {
    display: block;
    margin-bottom: 14px;
    padding: 12px;
    background: #fff;
    border: 1px solid #dce5f2;
    border-radius: 12px;
    box-shadow: 0 10px 24px rgba(15, 23, 42, 0.045);
  }

  .sch_M :deep(.datesearchPT),
  .sch_M :deep(.datesearchPTWarp),
  .sch_M :deep(.datesearch) {
    display: flex !important;
    flex-wrap: wrap !important;
    gap: 6px !important;
    width: 100% !important;
  }

  .sch_M :deep(input),
  .sch_M :deep(select) {
    height: 38px !important;
    border: 1px solid #d7e0ec !important;
    border-radius: 7px !important;
    background: #fff !important;
  }

  .sch_M :deep(.dateBtn),
  .sch_M :deep(.bga),
  .sch_M :deep(button),
  .sch_M :deep(a) {
    min-width: 48px;
    height: 38px !important;
    border-radius: 7px !important;
    background: #2563eb !important;
    color: #fff !important;
  }

  .strbtnPT {
    grid-template-columns: repeat(3, minmax(0, 1fr));
    gap: 8px;
  }

  .strbtnPT li {
    min-height: 72px;
    width: 100%;
    padding: 10px 5px;
    font-size: 13px;
    line-height: 1.25;
    word-break: keep-all;
  }

  .strbtnPT li span {
    margin-top: 7px;
    font-size: 19px;
    line-height: 1.1;
  }

  .line {
    border-radius: 10px;
  }

  .line :deep(table) {
    min-width: 980px;
  }
}

@media (max-width: 480px) {
  .strbtnPT {
    grid-template-columns: repeat(3, minmax(0, 1fr));
    gap: 8px;
  }

  .strbtnPT li {
    min-height: 70px;
    padding: 9px 4px;
    font-size: 12px;
  }

  .strbtnPT li span {
    margin-top: 6px;
    font-size: 18px;
  }
}

@media (max-width: 360px) {
  .strbtnPT {
    gap: 6px;
  }

  .strbtnPT li {
    min-height: 66px;
    padding: 8px 3px;
    font-size: 11px;
  }

  .strbtnPT li span {
    font-size: 16px;
  }
}
</style>
